import React from "react";
import { useParams } from "react-router-dom";
import { useFetchOptInConfig } from "features/metadesk/redux/hooks";
import { v4 as uuidv4 } from "uuid";
import OptInAddContent from "./OptInAddContent";
import { selectWebsiteOptIn } from "features/metadesk/redux/entityConfig/entityConfig.selector";
import { useIntl } from "react-intl";
import IntegrationAdd from "../components/IntegrationAdd";

const IntegrationOptInAdd = () => {
  const { formatMessage } = useIntl();
  const { fetchOptInConfig, optInConfig } = useFetchOptInConfig();
  const initOptInConfig = {
    apiKey: "",
    created: new Date(),
    domainName: "",
    title: "Stay up to date.",
    subtitle:
      "Get the latest updates and alerts directly to your email or favorite messaging apps. Never miss any important updates!",
    backgroundColor: "#ffffff",
    _id: uuidv4(),
    isNewAdd: true,
    connected: false,
  };

  return (
    <IntegrationAdd
      initConfig={initOptInConfig}
      config={optInConfig}
      fetchConfig={fetchOptInConfig}
      selectModule={selectWebsiteOptIn}
      contentComponent={OptInAddContent}
      apiPath="websiteOptIn"
      pageTitle={formatMessage({ id: "notification.subscribeBtn.headerTitle" })}
      pageDescription={formatMessage({
        id: "notification.subscribeBtn.headerDesc",
      })}
    />
  );
};

export default IntegrationOptInAdd;
